export default __webpack_public_path__ + "static/media/Custom Ink.0419ad69.jpg";